import { CaseSearchAddress, CaseSearchResultClient, Maybe } from '@acre/graphql'

import { DEFAULT_EMPTY_OPTION } from './GlobalCaseSearchOption'

export const getMultipleClientNameTag = (clients: Maybe<CaseSearchResultClient[]>) => {
  // Natural clients often have null value for is_natural_person field
  const company = clients?.find((client) => client?.is_natural_person === false)

  if (company?.organisation_name) {
    return company.organisation_name
  }

  // Get natural client names
  const clientNames = clients
    ?.map((client) => `${client.first_name || ''} ${client.last_name || ''}`.trim())
    .filter((name) => name)

  if (clientNames && clientNames.length > 0) {
    return clientNames.join(' + ')
  }

  return DEFAULT_EMPTY_OPTION
}

export const getDisplayedAddress = (address: Maybe<CaseSearchAddress>) => {
  if (!address) return DEFAULT_EMPTY_OPTION

  const { address1, post_town, postcode } = address
  const parts = [address1, post_town, postcode].filter(Boolean)

  return parts.join(', ') || DEFAULT_EMPTY_OPTION
}
